"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bloodTypeRh = exports.bloodType = void 0;
exports.convertUserDataByCsvData = convertUserDataByCsvData;
exports.isSearchEnum = exports.isBoolean = exports.hasValueEnum = exports.csvUserHeader = void 0;
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _moment = _interopRequireDefault(require("moment"));
var _appUtil = require("@/utils/app-util");
var isBoolean = exports.isBoolean = {
  Value: {
    0: false,
    1: true
  },
  Label: {
    false: 0,
    true: 1
  }
};
var isSearchEnum = exports.isSearchEnum = {
  Value: {
    '対象とする': 1,
    '対象としない': 0
  },
  Label: {
    1: '対象とする',
    0: '対象としない'
  }
};
var hasValueEnum = exports.hasValueEnum = {
  Value: {
    '有り': 1,
    '無し': 0
  },
  Label: {
    1: '有り',
    0: '無し'
  }
};
var bloodType = exports.bloodType = {
  Value: {
    'A': 1,
    'B': 2,
    'O': 3,
    'AB': 4
  },
  Label: {
    1: 'A',
    2: 'B',
    3: 'O',
    4: 'AB'
  }
};
var bloodTypeRh = exports.bloodTypeRh = {
  Value: {
    'RH+': 1,
    'RH-': 2
  },
  Label: {
    1: 'RH+',
    2: 'RH-'
  }
};
var csvUserHeader = exports.csvUserHeader = {
  Value: {
    'ｽﾀｯﾌ番号': 'staff_code',
    '登録日': 'entry_date',
    '検索対象': 'is_search',
    'スタッフ区分': 'staff_type',
    // '担当者名': 'admin_id',
    '氏名(ｶﾅ)': 'user_name_kana',
    '氏名(漢字)': 'user_name',
    '性別': 'gender',
    '配偶者': 'has_mate',
    '子供': 'has_child',
    '生年月日': 'birthday',
    '年齢': 'age',
    '血液型': 'blood_type',
    'RH': 'blood_type_rh',
    '郵便番号': 'post_code',
    '住所1': 'address',
    '住所2': 'address_2',
    '住所3': 'address_3',
    '最寄駅': 'home_station',
    '沿線1': 'home_station_line',
    '沿線2': 'home_station_line_2',
    '電話番号': 'phone_number',
    '電話番号メモ': 'phone_number_memo',
    '携帯電話': 'mobile_phone_number',
    '携帯電話メモ': 'mobile_phone_number_memo'
  },
  Label: ['ｽﾀｯﾌ番号', '登録日', '検索対象', 'スタッフ区分',
  // '担当者名',
  '氏名(ｶﾅ)', '氏名(漢字)', '性別', '配偶者', '子供', '生年月日', '年齢', '血液型', 'RH', '郵便番号', '住所1', '住所2', '住所3', '最寄駅', '沿線1', '沿線2', '電話番号', '電話番号メモ', '携帯電話', '携帯電話メモ']
};

/**
 * @param {string} path
 * @returns {Boolean}
 */
function convertUserDataByCsvData(_x) {
  return _convertUserDataByCsvData.apply(this, arguments);
}
function _convertUserDataByCsvData() {
  _convertUserDataByCsvData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(csvData) {
    var columnLabel, result, _loop, tempData, i;
    return regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          console.log(csvData);
          columnLabel = csvUserHeader.Label;
          console.log(columnLabel);
          result = []; // 行
          _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
            var data;
            return regeneratorRuntime.wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  data = csvData[i];
                  if (data['ｽﾀｯﾌ番号']) {
                    _context.next = 1;
                    break;
                  }
                  return _context.abrupt("return", 1);
                case 1:
                  console.log(data);
                  tempData = {}; // 対象カラム
                  columnLabel.forEach(function (header) {
                    var column = csvUserHeader.Value[header];
                    // スタッフ番号
                    if (header === 'ｽﾀｯﾌ番号') {
                      tempData[column] = (0, _appUtil.zeropadding)(data[header], 5);
                      // 検索対象
                    } else if (header === '検索対象') {
                      var val = isSearchEnum.Value[data[header]];
                      tempData[column] = isBoolean.Value[val];
                      // 配偶者, 子供
                    } else if (header === '配偶者' || header === '子供') {
                      var _val = hasValueEnum.Value[data[header]];
                      tempData[column] = isBoolean.Value[_val];
                      // 登録日, 誕生日
                    } else if (header === '登録日' || header === '生年月日') {
                      tempData[column] = (0, _moment.default)(data[header]).format('YYYY-MM-DD');
                      // 血液型
                    } else if (header === '血液型') {
                      tempData[column] = bloodType.Value[data[header]];
                      // 血液型 型
                    } else if (header === 'RH') {
                      tempData[column] = bloodTypeRh.Value[data[header]];
                    } else {
                      tempData[column] = data[header];
                    }
                    // password
                    tempData['password'] = (0, _appUtil.makePasswordHash)((0, _moment.default)(data['生年月日']).format('YYYYMMDD'));
                  });
                  console.log(tempData);
                  result.push(tempData);
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _loop);
          });
          i = 0;
        case 1:
          if (!(i < csvData.length)) {
            _context2.next = 4;
            break;
          }
          return _context2.delegateYield(_loop(), "t0", 2);
        case 2:
          if (!_context2.t0) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("continue", 4);
        case 3:
          i++;
          _context2.next = 1;
          break;
        case 4:
          return _context2.abrupt("return", result);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee);
  }));
  return _convertUserDataByCsvData.apply(this, arguments);
}